/**
 * converts a date string to a date, defaulting dates without day to the first of the month
 */
export const getConvertedExpirationDate = (expirationDate: string, hasFullExpirationDate: boolean) =>
  hasFullExpirationDate ? new Date(expirationDate) : new Date(`${expirationDate}-01`);
